import firebase from 'firebase/app';
import 'firebase/database';
import Rebase from 're-base';
import 'firebase/auth';

// Initialize firebase
const config = {
    apiKey: "AIzaSyAP2UuHa1EG-psGxw5-0B-etDH4gk7moG8",
    authDomain: "chatgonia.firebaseapp.com",
    databaseURL: "https://chatgonia.firebaseio.com",
    projectId: "chatgonia",
    storageBucket: "chatgonia.appspot.com",
    messagingSenderId: "11270289547"
};

const app = firebase.initializeApp(config);

// Configure authentication
const googleProvider = new firebase.auth.GoogleAuthProvider();
const githubProvider = new firebase.auth.GithubAuthProvider();
const auth = firebase.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);

// Configure database
const db = firebase.database(app);
const base = Rebase.createClass(db);

export { app, base, auth, googleProvider, githubProvider };


// WEBPACK FOOTER //
// ./src/base.js